import { type ReactElement, type ReactNode } from 'react';

const NOTE =
  'pointer-events-none rounded-lg bg-foreground px-2 py-1 text-xs font-semibold whitespace-nowrap text-background shadow-lg';

// The moment the pointer lands, where a native title waits a second first. §15
export function HoverNote({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}): ReactElement {
  return (
    <span className="group relative inline-flex">
      {children}
      <span
        role="note"
        className={`absolute end-0 bottom-full z-90 mb-1 hidden ${NOTE} group-hover:block`}
      >
        {label}
      </span>
    </span>
  );
}

export type PointerNoteAt = { readonly label: string; readonly x: number; readonly y: number };

// Fixed to the page, because a tile's own scrolling box would clip its note.
export function PointerNote({ note }: { note: PointerNoteAt | null }): ReactElement | null {
  if (note === null) return null;
  return (
    <span
      role="note"
      style={{ left: note.x, top: note.y }}
      className={`fixed z-90 -translate-x-1/2 -translate-y-[calc(100%+10px)] ${NOTE}`}
    >
      {note.label}
    </span>
  );
}
